
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pemetaan-kompetensi/pakta-integritas",
      function () {
        return require("private-next-pages/pemetaan-kompetensi/pakta-integritas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pemetaan-kompetensi/pakta-integritas"])
      });
    }
  